/** @format */

import React, {  useState } from "react";
import { Button, Modal, Col } from "react-bootstrap";
import Select from "react-select";
import { Style } from "utils/select";
import { toast } from "react-toastify";
import { useGetCohortsQuery } from "store/services/adminAPI";
import { useGetProviderCoursesQuery } from "store/services/providerAPI";
import { weeks } from "utils/constant.data";
import { ReactComponent as ResetIcon } from "images/svg/reset.svg";
import { ClearIndicator } from "component/ClearIndicator";
import { LocalGov, Nigerian_States } from "utils/constant.data";

export const FilterModal = ({
  showModal,
  setShowFilter,
  setFilter,
  filtering,
}) => {
  const [selectedWeek, setWeek] = useState(null);
  const [selectedCohorts, setCohorts] = useState(null);
  const [selectedCategory, setCategory] = useState(null);
  const [selectedLGA, setLGA] = useState(null);
  const [selectedState, setSelectedState] = useState(null);
  const [sessions, setSessions] = useState(null);

  const [LGAs, setLGAs] = useState([]);

  const { data: courses, isLoading: fetchingCourses } =
    useGetProviderCoursesQuery();
  const { data: cohorts, isLoading: loadingCohorts } = useGetCohortsQuery("");

  const handleFilter = () => {
    if (
      !selectedWeek &&
      !selectedCohorts &&
      !sessions &&
      !selectedCategory &&
      !selectedLGA
    ) {
      toast.warn("✔️ Please Select a Filter !", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } else {
      setFilter({
        cohort_rank: selectedCohorts?.value ? selectedCohorts?.value : "",
        sessions: sessions ? sessions : "",
        weeks: selectedWeek?.length > 0 ? selectedWeek : [],
        course: selectedCategory?.length > 0 ? selectedCategory : [],
        lga: selectedLGA?.length > 0 ? selectedLGA : [],
      });
    }
  };

  const isFilterSelected = () => {
    return (
      selectedCohorts?.value ||
      sessions?.length > 0 ||
      selectedWeek?.length > 0 ||
      selectedCategory?.length > 0 ||
      selectedLGA?.length > 0
    );
  };

  const CohortOptions =
    cohorts?.data?.cohorts?.length > 0
      ? cohorts?.data?.cohorts?.map((cohort) => ({
          value: cohort?.rank,
          label: `Cohort ${cohort?.rank}`,
        }))
      : [];

  const Categories =
    courses?.data
      ?.filter((_) => {
        return _?.course?.status;
      })
      ?.map((role) => ({
        value: role?.course?.id,
        label: role?.course?.title,
        code: role?.course?.code,
      })) ?? [];

  const handleChange = (e) => {
    const value = e.target.value;
    if (/^\d*\.?\d*$/.test(value)) {
      setSessions(value);
    } else {
      setSessions(null);
    }
  };

  const clear = () => {
    setWeek(null);
    setCohorts(null);
    setCategory(null);
    setLGA(null);
    setSessions(null);
  };

  return (
    <>
      <Modal
        show={showModal}
        onHide={() => setShowFilter(false)}
        className="modal fade"
        id="postModal"
      >
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Filter Fellows</h5>
            <Button
              variant=""
              type="button"
              className="close"
              data-dismiss="modal"
              onClick={() => {
                clear();
                setShowFilter(false);
              }}
            >
              <span>×</span>
            </Button>
          </div>
          <div className="modal-body">
            <div className="basic-form">
              <form onSubmit={(e) => e.preventDefault()}>
                <div className="col-lg-12">
                  <div className="form-group mb-3">
                    <label>Week Number</label>
                    <Select
                      components={{ ClearIndicator }}
                      value={selectedWeek}
                      onChange={setWeek}
                      options={weeks}
                      styles={Style}
                      isMulti
                    />
                  </div>
                </div>

                {loadingCohorts ? (
                  <p>Loading Cohorts.....</p>
                ) : (
                  CohortOptions &&
                  CohortOptions?.length > 0 && (
                    <Col md={12}>
                      <p className="p-1 m-0">Filter by Cohort</p>
                      <div className="form-group mb-3">
                        <Select
                          value={selectedCohorts}
                          onChange={setCohorts}
                          options={CohortOptions}
                          styles={Style}
                        />
                      </div>
                    </Col>
                  )
                )}

                {fetchingCourses ? (
                  <p>Loading Courses.....</p>
                ) : (
                  Categories && (
                    <Col md={12}>
                      <p className="p-1 m-0">Filter by Course</p>
                      <div className="form-group mb-3">
                        <Select
                          value={selectedCategory}
                          onChange={setCategory}
                          options={Categories}
                          styles={Style}
                          components={{ ClearIndicator }}
                          isMulti
                        />
                      </div>
                    </Col>
                  )
                )}

                <Col md={12}>
                  <p className="p-1 m-0">Select State</p>
                  <div className="form-group mb-3">
                    {/* <p>{JSON.stringify(selectedState)}</p> */}
                    <Select
                      value={selectedState}
                      onChange={(e) => {
                        setSelectedState(e);

                        const allLgas = LocalGov.filter((localGov) =>
                          e.some((state) => state.value === localGov.state)
                        ).flatMap((localGov) => localGov.lgas);

                        const LGAS =
                          allLgas?.map((role) => ({
                            value: role,
                            label: role,
                          })) ?? [];

                        setLGAs([...LGAS]);
                      }}
                      options={Nigerian_States?.map((role) => {
                        return {
                          value: role,
                          label: role,
                        };
                      })}
                      styles={Style}
                      components={{ ClearIndicator }}
                      isMulti
                    />
                  </div>
                </Col>

                <Col md={12}>
                  <p className="p-1 m-0">Filter by LGAs</p>
                  <div className="form-group mb-3">
                    <Select
                      value={selectedLGA}
                      onChange={setLGA}
                      options={LGAs}
                      styles={Style}
                      components={{ ClearIndicator }}
                      isMulti
                    />
                  </div>
                </Col>

                <div className="mb-3">
                  <label className="mb-1">
                    <strong>Sessions</strong>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="sessions"
                    name="sessions"
                    placeholder="Number of Sessions"
                    value={sessions}
                    onChange={handleChange}
                  />
                </div>
              </form>
            </div>

            <div className="filter-section">
              <div className="filter-group">
                <div className="score-range-container">
                  <button
                    className="reset-filter"
                    onClick={() => {
                      clear();
                    }}
                  >
                    <ResetIcon />
                    Reset Filter
                  </button>
                  <button
                    className="show-results-button"
                    disabled={isFilterSelected() ? false : true}
                    onClick={() => {
                      handleFilter();
                    }}
                  >
                    {filtering ? "Filtering ...." : "Show Result"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default FilterModal;

// weeks
// sessions
// cohort_rank
// course
// lga
